module.exports = __webpack_public_path__ + "img/42ne.5855cc80.svg";